import http from "../../utils/httpClient";

class festivalService {
  getFestivalCategory = async (query) => {
    return await http.get("/api/Festival/GetFestivalCategory", {
      params: query,
    });
  };

  createOrUpdateFestivalCategory = async (data) => {
    return await http.post("/api/Festival/CreateFestival", data);
  };

  addFestivalProductList = async (data) => {
    return await http.post(
      `/api/Festival/AddProductsInFestivalCategory?productIds=${data.productIds}&displayOrders=${data.displayOrders}&festivalId=${data.festivalId}&isActive=${data.isActive}`,
    );
  };

  editFestivalProductList = async (data) => {
    return await http.post(
      `/api/Festival/UpdateFestivalDisplayOrder?productIds=${data.productIds}&displayOrders=${data.displayOrders}&festivalId=${data.festivalId}`,
    );
  };

  getAddibleFestivalProducts = async (query) => {
    return await http
      .get("/api/Festival/GetFestivalProductListByCategory", { params: query })
      .then((response) => {
        return response;
      })
      .catch((err) => Promise.reject("Failed!", err));
  };

  getFestivalProducts = async (query) => {
    return await http
      .get("/api/Festival/GetFestivalProductListByCategory", { params: query })
      .then((response) => {
        return response;
      })
      .catch((err) => Promise.reject("Failed!", err));
  };

  festivalProductStatusChange = async (data) => {
    return await http.post(
      `/api/Festival/FestivalCategoryProductStatusChange?festivalId=${data?.festivalId}&productId=${data?.productId}&isActive=${data?.isActive}`,
    );
  };

  getDownloadableFestivalProducts = async (query) => {
    return await http
      .get("/api/Festival/GetFestivalProductListByCategory", { params: query })
      .then((response) => {
        return response;
      })
      .catch((err) => Promise.reject("Failed!", err));
  };
}

export default new festivalService();
